import { MobileTimePicker } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";
import React from "react";

interface TimeFieldProps {
  label: string;
  value: Dayjs;
  maxTime?: Dayjs;
  onChange: (value: Dayjs) => void;
}

export default function TimeField({
  label,
  value,
  maxTime,
  onChange,
}: TimeFieldProps) {
  return (
    <MobileTimePicker
      maxTime={maxTime}
      value={value}
      label={label}
      onChange={onChange}
      closeOnSelect={true}
    />
  );
}
